import { render, staticRenderFns } from "./OwnNumberForm.vue?vue&type=template&id=0f9acd2d&scoped=true"
import script from "./OwnNumberForm.vue?vue&type=script&lang=js"
export * from "./OwnNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9acd2d",
  null
  
)

export default component.exports